"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IChargeTiers = exports.IChargeTier = exports.TierResetBy = exports.TierOperators = exports.TierType = void 0;
const openapi_1 = require("../../../openapi");
var TierType;
(function (TierType) {
    TierType["Graduated"] = "graduated";
    TierType["Absolute"] = "absolute";
})(TierType = exports.TierType || (exports.TierType = {}));
var TierOperators;
(function (TierOperators) {
    TierOperators["Noop"] = "noop";
    TierOperators["Between"] = "between";
    TierOperators["LessThanOrEqual"] = "lessthanorequal";
    TierOperators["GreaterThan"] = "greaterthan";
    /**
     * These are left here in case of an eventual implementation of these operators
     */
    // LessThan = "lessthan",
    // GreaterThanOrEqual = "greaterthanorequal",
})(TierOperators = exports.TierOperators || (exports.TierOperators = {}));
var TierResetBy;
(function (TierResetBy) {
    TierResetBy["Location"] = "location";
    TierResetBy["Lot"] = "lot";
    TierResetBy["SKU"] = "sku";
    TierResetBy["ItemClassification"] = "itemclassification";
})(TierResetBy = exports.TierResetBy || (exports.TierResetBy = {}));
class IChargeTier {
    operator;
    from;
    to;
    chargeAmount;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(TierOperators) })
], IChargeTier.prototype, "operator", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IChargeTier.prototype, "from", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IChargeTier.prototype, "to", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IChargeTier.prototype, "chargeAmount", void 0);
exports.IChargeTier = IChargeTier;
class IChargeTiers {
    type;
    resetBy;
    tiers;
    chargeMinimumAmount;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(TierType) })
], IChargeTiers.prototype, "type", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(TierResetBy) })
], IChargeTiers.prototype, "resetBy", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IChargeTier) })
], IChargeTiers.prototype, "tiers", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IChargeTiers.prototype, "chargeMinimumAmount", void 0);
exports.IChargeTiers = IChargeTiers;
